var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"h2 text-white text-center mb-xxl-3 d-lg-none d-xxl-block"},[_vm._v(" "+_vm._s(_vm.$t(`Featured`))+" ")]),_c('button',{staticClass:"btn btn-block font-weight-bold",class:{
      'btn-white': _vm.isActiveTag,
      'btn-secondary': !_vm.isActiveTag,
    },on:{"click":function($event){return _vm.setTag(_vm.tag)}}},[_vm._v(" "+_vm._s(_vm.$t(`Women`))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }